// import axios from "axios";

// const basicAuth =
//   "Basic " + btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

// const axInstBasic = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   headers: {
//     Authorization: basicAuth,
//   },
//   withCredentials: true
// });

// const axInst = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   withCredentials: true 
// });

// export { axInst, axInstBasic };

// Current working code

import axios from "axios";
const basicAuth =
  "Basic " +
  btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
const axInstBasic = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: basicAuth,
  },
});

const axInst = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axInst.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axInst, axInstBasic };
